export default {"src":"/_next/static/media/United-Arab-Emirates-Flag.26465ee4.svg","height":600,"width":1200};